import React, { useState, useEffect } from "react";
import { getAdminDocumentStats } from "../../../utils/Api";

interface DocumentStats {
  total_documents: number;
  total_pages: number;
  personal_documents: number;
  organization_documents: number;
}

const StatsCards: React.FC = () => {
  const [stats, setStats] = useState<DocumentStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await getAdminDocumentStats();
        setStats(response.data);
      } catch (err) {
        setError("Failed to load statistics");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white rounded shadow p-4 sm:p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 text-red-600 rounded shadow p-4">
        {error}
      </div>
    );
  }

  const cards = [
    {
      label: "Total Documents",
      value: stats?.total_documents ?? 0,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      label: "Total Pages",
      value: stats?.total_pages ?? 0,
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      label: "Personal Documents",
      value: stats?.personal_documents ?? 0,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
    {
      label: "Organisation Documents",
      value: stats?.organization_documents ?? 0,
      color: "text-orange-600",
      bgColor: "bg-orange-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white rounded shadow p-4 sm:p-6">
          <p className="text-xs sm:text-sm text-gray-500 mb-1">{card.label}</p>
          <p className={`text-2xl sm:text-3xl font-semibold ${card.color}`}>
            {card.value.toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
